export const APPOINTMENTS_FETCH_REQUEST = 'APPOINTMENTS_FETCH_REQUEST';
export const APPOINTMENTS_FETCH_SUCCESS = 'APPOINTMENTS_FETCH_SUCCESS';
export const APPOINTMENTS_FETCH_FAILURE = 'APPOINTMENTS_FETCH_FAILURE';
export const APPOINTMENTS_CREATE_REQUEST = 'APPOINTMENTS_CREATE_REQUEST';
export const APPOINTMENTS_CREATE_SUCCESS = 'APPOINTMENTS_CREATE_SUCCESS';
export const APPOINTMENTS_CREATE_FAILURE = 'APPOINTMENTS_CREATE_FAILURE';
export const APPOINTMENTS_UPDATE_REQUEST = 'APPOINTMENTS_UPDATE_REQUEST';
export const APPOINTMENTS_UPDATE_SUCCESS = 'APPOINTMENTS_UPDATE_SUCCESS';
export const APPOINTMENTS_UPDATE_FAILURE = 'APPOINTMENTS_UPDATE_FAILURE';
export const APPOINTMENTS_DELETE_REQUEST = 'APPOINTMENTS_DELETE_REQUEST';
export const APPOINTMENTS_DELETE_SUCCESS = 'APPOINTMENTS_DELETE_SUCCESS';
export const APPOINTMENTS_DELETE_FAILURE = 'APPOINTMENTS_DELETE_FAILURE';
export const APPOINTMENTS_SET_SELECTED = 'APPOINTMENTS_SET_SELECTED';
export const APPOINTMENTS_CLEAR_SELECTED = 'APPOINTMENTS_CLEAR_SELECTED';
export const APPOINTMENTS_SET_LOADING = 'APPOINTMENTS_SET_LOADING';
export const APPOINTMENTS_SET_ERROR = 'APPOINTMENTS_SET_ERROR';
export const APPOINTMENTS_CLEAR_ERROR = 'APPOINTMENTS_CLEAR_ERROR';